import React, { useEffect, useState } from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import ajaxInventoryReports from "../../util/remote/ajaxInventoryReports";
ChartJS.register(ArcElement, Tooltip, Legend, ChartDataLabels);
export default function StationFuelBalancesChart({ stationId }) {
  const station_id = Number(localStorage.getItem("FuelFy@station_id"));
  const [chartData, setChartData] = useState(null);
  const [loading, setLoading] = useState(true);
  // Fixed color palette
  const COLORS = [
    "#13432bff",
    "#4BC0C0",
    "#9966FF",
    "#FF9F40",
    "#d63384ff",
    "#2e7d32ff",
    "#98880cff",
    "#0c986eff",
  ];
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const response =
        await ajaxInventoryReports.Current_station_inventory_stock({
          station_id: station_id,
        });
      // Validate response and details
      if (!response || !response.details || response.details.length === 0) {
        return;
      }
      const labels =
        Array.isArray(response.details) &&
        response.details.map((d) => d.fuel_category);
      const data =
        Array.isArray(response.details) &&
        response.details.map((d) => d.balance);
      const backgroundColor =
        Array.isArray(labels) &&
        labels.map((_, i) => COLORS[i % COLORS.length]);
      setChartData({
        labels,
        datasets: [
          {
            data,
            backgroundColor,
          },
        ],
      });
      setLoading(false);
    };
    fetchData();
  }, [stationId]);
  if (loading) return <div className="text-center p-4">Loading chart...</div>;
  if (!chartData)
    return <div className="text-center p-4">No data available</div>;
  return (
    <div style={{ width: "100%", height: "100%" }}>
      <Doughnut
        data={chartData}
        options={{
          responsive: true,
          maintainAspectRatio: false, // fill parent height
          plugins: {
            legend: { position: "bottom" },
            title: {
              display: true, // enable title
              text: "Fuel Balances", // your title text
              font: { size: 14, weight: "bold" },
              padding: { top: 10, bottom: 20 },
            },
            tooltip: { enabled: true },
            datalabels: {
              color: "#fff",
              font: { weight: "bold", size: 12 },
              formatter: (value, context) => value.toLocaleString(),
            },
          },
        }}
        plugins={[ChartDataLabels]}
      />
    </div>
  );
}
